




class WidgetEventsUtility {




  constuctor() {
    this.widget = {};
  }






  setWidgetInfo(widget) {
    if (typeof widget !== "object") throw('An object must be passed to setWidgetInfo.')
    widget.version = widget.oldVersion ? widget.oldVersion : widget.version;
    this.widget = widget;
  }







  sub(eventName, callback) {
    const widget = this.widget;
    if (Object.getOwnPropertyNames(widget).length)
      return window.sparta.widgets[widget.loader_version][widget.name][widget.version][widget.id].events.sub(eventName, callback);
  }







  pub(eventName, mssg = {}) {
    const widget = this.widget;
    if (Object.getOwnPropertyNames(widget).length)
      return window.sparta.widgets[widget.loader_version][widget.name][widget.version][widget.id].events.pub(eventName, mssg, widget);
  }







  unsub(eventName, callback) {
    const widget = this.widget;
    if (Object.getOwnPropertyNames(widget).length)
      return window.sparta.widgets[widget.loader_version][widget.name][widget.version][widget.id].events.unsub(eventName, callback);
  }







  once(eventName, callback) {
    const widget = this.widget;
    if (Object.getOwnPropertyNames(widget).length)
      return window.sparta.widgets[widget.loader_version][widget.name][widget.version][widget.id].events.once(eventName, callback);
  }
}

export default new WidgetEventsUtility();
